import { hookSchema } from '../models/hook.schema';
import { duplicateHookPayloadSchema } from './duplicate.schema';

export type DuplicateHookPayload = {
  name: string;
  copyDependencies?: boolean;
  copySecrets?: boolean;
  copyQueues?: boolean;
};

export const duplicate = (hookId: number, payload: DuplicateHookPayload) => {
  return {
    endpoint: `/hooks/${hookId}/duplicate`,
    method: 'POST',
    responseSchema: hookSchema,
    payloadSchema: duplicateHookPayloadSchema,
    payload,
  } as const;
};
